module.exports = __webpack_public_path__ + "img/trustpilot-large.3b1e92c.png";